const OutdoorEvents = [
  {
    id: 1,
    Event: "The Rebel, The Princess, The Rainbow, The bourgeois",
    Date: "Sat, 7 Jan",
    Place: "Jagriti Theatre : Whitefield, Bengaluru",
    Info: "'The Rebel, The Princess, The Rainbow and The Bourgeois' is an original musical satire about four mannequins and a security guard;whom they are terrified of, and their dramatic nights under the shutters in a textile shop.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCA3IEphbg%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00348371-cbvdylqlag-portrait.jpg",
  },
  {
    id: 2,
    Event: "Kanta Mattu Kanta",
    Date: "Thu, 5 Jan onwards",
    Place: "Ranga Shankara : Bengaluru",
    Info: "In association with Agraharam presents a wonderful extravaganza for a period of one-month nonstop Art and Culture program for enthusiastic audiences starting from the Auspicious month of Marghazi on 16.12.2022.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-VGh1LCA1IEphbiBvbndhcmRz,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00317017-fpvwevkjbj-portrait.jpg",
  },
  {
    id: 3,
    Event: "Jawaharlal Nehru Bengaluru",
    Date: "Wed, 4 Jan onwards",
    Place: "Jawaharlal Nehru Planetarium : Bengaluru",
    Info: "“Natural Selection”: this is a forty-minute audio-visual program, describes Darwin’s voyage to Galapagos Islands, the bio diversity he saw there, the keen observations he made and his analysis that lead to the famous book “On the Origin of Species by means of Natural Selection”.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-V2VkLCA0IEphbiBvbndhcmRz,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00063757-zksufrpcxf-portrait.jpg",
  },
  {
    id: 4,
    Event: "Excuse Me Brother",
    Date: "Sat, 14 Jan onwards",
    Place: "Good Shepherd Auditorium : Bengaluru",
    Info: "This stand-up solo show is an amalgamation of observational humor & personal anecdotes topped with energetic act-outs on stage. Also known as `Mr Versatile`, Aakash is known for his sudden jokes, character comedy, quirky observations and a stellar performance.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAxNCBKYW4gb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00339150-dlwtyzwmef-portrait.jpg",
  },
  {
    id: 5,
    Event: "Nothing like Lear",
    Date: "Fri 13 Jan 2023 - Sun 15 jan 2023",
    Place: "Ranga Shankara : Bengaluru",
    Info: "Ever thought about what a clown does when he is depressed? It sure is tough being a clown. Here is one who hasn’t stopped crying for days. And he has plenty of reasons for it.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-RnJpLCAxMyBKYW4gb253YXJkcw%3D%3D,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00345748-zwmzplfbtt-portrait.jpg",
  },
  {
    id: 6,
    Event: "The Art of Harikatha Workshop",
    Date: "Sat 11 Feb 2023 at 8.00 PM",
    Place: "Zoom",
    Info: "Lavanya Srinivas, will facilitate this interactive workshop in which participants will experience and learn the elements of the composite art form of Harikatha, a rich oral storytelling tradition of South India.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U2F0LCAxMSBGZWI%3D,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00348721-sldtcyztda-portrait.jpg",
  },
  {
    id: 7,
    Event: "Oh Hello! By Rahul Dua - INDIA TOUR",
    Date: "Thu 12 jan 2023 - Sun 12 Feb 2023",
    Place: "Multiple Venues",
    Info: "As one of the best performers on Amazon Prime Video`s Comicstaan S01, Rahul Dua is one of the brightest young comics in the country today. Combining small town charm with big city disillusionment, Rahul’s comedy is as funny as it is relevant.",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-U3VuLCAyMiBKYW4%3D,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00343031-ukcvxkesuu-portrait.jpg",
  },
  {
    id: 7,
    Event: "Saarang - Choreo Night",
    Date: "Thu 12 Jan 2023 at 6.00 PM",
    Place: "IIT Madras Open Air Theatre : Chennai",
    Info: "The biggest intercollegiate dance competition with astonishing performances of colleges from across the country in front of internationally acclaimed judges. Get ready for a night of exhilarating, jaw-dropping performances!",
    src: "https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:ote-VGh1LCAxMiBKYW4%3D,ots-29,otc-FFFFFF,oy-612,ox-24:q-80/et00346395-sejrjxmkzv-portrait.jpg",
  }
];

export default OutdoorEvents;
